import { render } from "./QuizFrame.vue?vue&type=template&id=d2682810&scoped=true"
import script from "./QuizFrame.vue?vue&type=script&lang=js"
export * from "./QuizFrame.vue?vue&type=script&lang=js"

import "./QuizFrame.vue?vue&type=style&index=0&id=d2682810&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d2682810"]])

export default __exports__